const React = require('react');
const trim = require('mn-utils/trim');
const changeProviderProvider = require('mn-utils/changeProviderProvider');
const withState = require('../../../../utils/withState');
const {
  apiHelp,
} = require('../../../../api/merchant/help');
const {
  openPopupInfo,
} = require('../../../../emitters/popup');
const Caption = require('../../../dumb/Caption/C');
const TextField = require('../../../dumb/TextField/A');
const Button = require('../../../dumb/Button/Accept');
const WrapperWithLoading = require('../../../dumb/WrapperWithLoading/B');
const {account$} = require("../../../../emitters/account");


module.exports = withState((setState) => {
  const changeProvider = changeProviderProvider(setState);

  const handleChangeSubject = changeProvider('subject', null, (v) => v.substr(0, 200));
  const handleChangeQuestion = changeProvider('question', null, (v) => v.substr(0, 15000));

  return (state) => {
    const {
      clicked,
    } = state;

    const subject = state.subject || '';
    const _subject = trim(subject);
    const invalidSubject = !_subject;

    const question = state.question || '';
    const _question = trim(question);
    const invalidQuestion = !_question || _question.length > 15000;


    const disabled = invalidQuestion
      // || invalidSubject

    return (
      <WrapperWithLoading
        loading={state.loading}
      >
        <div className="layoutRow fhaB fvaC">
          <Caption>Lunu Support</Caption>
        </div>
        <div className="mt30 wmax430 w@m">
          {/*<TextField*/}
          {/*  label="Subject *"*/}
          {/*  value={subject}*/}
          {/*  onChange={handleChangeSubject}*/}
          {/*  error={clicked && invalidSubject}*/}
          {/*  helperText="Obligatory field"*/}
          {/*/>*/}
          <TextField
            className="mt30 h140>textarea"
            label="Your Question *"
            value={question}
            onChange={handleChangeQuestion}
            error={clicked && invalidQuestion}
            helperText="Obligatory field"
            maxLength={15000}
            withCount
            multiline
          />
        </div>
        <div className="layoutRow fhaS fvaC mt36">
          <Button
            disabled={clicked && disabled}
            onClick={() => {
              if (disabled) {
                setState({
                  clicked: true,
                });
                return;
              }
              setState({
                loading: true,
              });

              apiHelp({
                email: state.account.login,
                message: trim(question),
                attachments: [],
              }).finally((error) => {
                const next = {
                  loading: false,
                };
                if (!error) {
                  next.subject = '';
                  next.question = '';
                  next.clicked = false;
                  openPopupInfo(['Help', 'Your question has been sent']);
                }
                setState(next);
              });
            }}
          >
            Submit
          </Button>
        </div>
      </WrapperWithLoading>
    );
  };
}, {
  account: account$,
});
